import React, { useEffect, useState } from 'react';
import { getProductsAll } from '../../api/products';
import { getAllMarkertName } from '../../api/market'; 
import { AddMarketData } from '../../api/marketIntelligency';
import AddMarket from './AddMarket';

function FormMarket() {
    const [loading, setLoading] = useState(false);
    const [productData, setProductData] = useState([]);
    const [isVisibleNewMarkert, setIsVisibleNewMarkert] = useState(false);
    const [marketDatas, setMarketDatas] = useState([]);

    const [productID, setProductID] = useState("");
    const [price, setPrice] = useState("");
    const [marketName, setMarketName] = useState("");
    const [regName, setRegName] = useState("");
    const [regMobile, setRegMobile] = useState("");
    const [date, setDate] = useState("");
    const [marketLocation, setMarketLocation] = useState("");
    const [currency, setCurrency] = useState("");

    useEffect(() => {
        setLoading(true);
        getProductsAll((result) => {
            if (result.ok !== 1) {
                console.log(result);
                return;
            }
            setProductData(result.result);
        });
        getAllMarkertName((result) => {
            if (result.ok !== 1) {
                console.log(result);
                return;
            }
            setMarketDatas(result.result);
        });
        setLoading(false);
    }, []);

    const clearForm = () => {
        setProductID("");
        setPrice("");
        setMarketName("");
        setRegName("");
        setRegMobile("");
        setDate("");
        setMarketLocation("");
        setCurrency("");
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!productID || !price || !marketName || !marketLocation || !regName || !regMobile || !date) {
            alert("All fields are required!");
            return;
        }

        const MarketIntelligenceData = {
            productID,
            price,
            marketName,
            marketLocation,
            regName,
            regMobile,
            date,
            currency,
        };

        AddMarketData(MarketIntelligenceData, (result) => {
            if (result.ok !== 1) {
                console.log(result);
                return;
            }
            alert("Data saved successfully!");
            clearForm(); 
        });
    };

    return (
        <div className="col-md-10 col-lg-8 mx-auto mt-4">
            <form method="post">
                <div className="card">
                    <div className="card-body">
                        <div className="form-group">
                            <label>Product Name</label>
                            <select
                                className="form-control"
                                onChange={(e) => setProductID(e.target.value)}
                                value={productID}
                                name="productName"
                            >
                                <option value="">--Select Product--</option>
                                {productData.map((item) => (
                                    <option key={item.productID} value={item.productID}>
                                        {item.name} -- {item.unit}
                                    </option>
                                ))}
                            </select>
                        </div>
               <div className='row'>
                <div className='col md-6'>
                <div className="form-group">
                <label>Currency</label>
                <select onChange={(e) => setCurrency(e.target.value)} value={currency} className='form-control'>
                  <option value="">--Currency--</option>
                  <option value="TSH">TSH</option>
                  <option value="KSH">KSH</option>
                  <option value="UGX">UGX</option>
                  <option value="DOLLAR">DOLLAR</option>
                </select>
                </div>
                </div>
                <div className='col md-6'>
                <div className="form-group">
                            <label>Price</label>
                            <input
                                type="number"
                                onChange={(e) => setPrice(e.target.value)}
                                value={price}
                                placeholder="Price"
                                className="form-control"
                            />
                        </div>

                </div>
               </div>

                      
                        


                        <div className="form-group">
                            {isVisibleNewMarkert ? (
                                <AddMarket
                                    setIsVisibleNewMarkert={setIsVisibleNewMarkert}
                                    setMarketDatas={setMarketDatas}
                                />
                            ) : (
                                <div className="form-group">
                                    <label>Market Name</label>
                                    <div className="d-flex align-items-center">
                                        <select
                                            className="form-control flex-grow-1"
                                            onChange={(e) => setMarketName(e.target.value)}
                                            value={marketName}
                                            name="marketName"
                                        >
                                            <option value="">--Select Market Name--</option>
                                            {marketDatas.map((item) => (
                                                <option key={item.name}>{item.name}</option>
                                            ))}
                                        </select>
                                        <button
                                            className="btn btn-primary btn-sm ml-2"
                                            type="button"
                                            onClick={() => setIsVisibleNewMarkert(true)}
                                        >
                                            +
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="form-group">
                            <label>Market Location</label>
                            <input
                                type="text"
                                onChange={(e) => setMarketLocation(e.target.value)}
                                value={marketLocation}
                                placeholder="Market Location"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label>Registration Person (Full Name)</label>
                            <input
                                type="text"
                                onChange={(e) => setRegName(e.target.value)}
                                value={regName}
                                placeholder="Full Name"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label>Registration Person (Mobile Number)</label>
                            <input
                                type="number"
                                onChange={(e) => setRegMobile(e.target.value)}
                                value={regMobile}
                                placeholder="Mobile Number"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label>Date</label>
                            <input
                                type="date"
                                onChange={(e) => setDate(e.target.value)}
                                value={date}
                                placeholder="Date"
                                className="form-control"
                            />
                        </div>
                        <button
                            onClick={handleSubmit}
                            type="submit"
                            className="btn btn-success btn-block mt-3"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default FormMarket;
